import { Button } from 'react-bootstrap';
import { getPhieuTheoDoiDHSTGanNhat } from '../../../../../../../../../services/BenhAnServices';
import { useFormikContext } from 'formik';
import { usePhanHeDieuTriNoiTruContext } from '../../../../../../../../../PhanHeDieuTriContext';
import { CODE } from '../../../../../../../../../../utils/Constant';

const CapNhatTuPhieuChucNangSongButton = () => {
	const { benhNhanDieuTri } = usePhanHeDieuTriNoiTruContext();
	const { values, setFieldValue } = useFormikContext<any>();

	const handleUpdate = async () => {
		try {
			let { data } = await getPhieuTheoDoiDHSTGanNhat(benhNhanDieuTri?.medicalRecordCode);
			if (data?.code === CODE.SUCCESS) {
				let dataDHST = data?.data;
				delete dataDHST?.createdDate;
				delete dataDHST?.doctorName;
				setFieldValue("phieuDieuTri", {
					...values?.phieuDieuTri,
					...dataDHST,
				});
			}
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<div className='d-flex align-items-end h-100'>
			<Button className="link-info bg-white text-decoration-underline spaces p-0"
				onClick={handleUpdate}
			>
				Cập nhật từ phiếu theo dõi chức năng sống gần nhất
			</Button>
		</div>
	);
};

export default CapNhatTuPhieuChucNangSongButton;
